const DEFAULT_TOKEN_LIFETIME_MS = 24 * 60 * 60 * 1000;

function decodeJwtPayload(token) {
  const payload = String(token).split(".")[1];
  if (!payload) return null;

  const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized.padEnd(
    normalized.length + ((4 - (normalized.length % 4)) % 4),
    "="
  );

  return JSON.parse(atob(padded));
}

export function getTokenExpirationTime(token, now = Date.now()) {
  try {
    const expirationSeconds = Number(decodeJwtPayload(token)?.exp);
    if (Number.isFinite(expirationSeconds)) {
      return expirationSeconds * 1000;
    }
  } catch {
    // Some environments may return an opaque token instead of a JWT.
  }

  return now + DEFAULT_TOKEN_LIFETIME_MS;
}

export function isTokenExpired(expirationTime, now = Date.now()) {
  return !Number.isFinite(Number(expirationTime)) || now >= Number(expirationTime);
}
